import { Text } from '@cinch-labs/design-system'
import cx from 'classnames'
//import { useResponsiveEnvironment } from '@cinch-nx/search-shared'
import { useResponsiveEnvironment } from '@cinch-nx/search-shared'
import {
  representativeExample as representativeExampleData,
  type RepresentativeExampleTypes,
} from './representative-example.data'
import styles from './representative-example.module.css'

export interface RepresentativeExampleProps {
  headingLevel: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  representativeExample?: RepresentativeExampleTypes
  element?: keyof JSX.IntrinsicElements
}

export const RepExample = ({
  representativeExample = representativeExampleData,
  headingLevel,
}: // eslint-disable-next-line arrow-body-style
RepresentativeExampleProps) => {
  const { isMobile, isTablet } = useResponsiveEnvironment()
  if (isMobile || isTablet) {
    return (
      <section
        className={cx(styles.repExample, styles.repExampleVariant)}
        aria-labelledby="representativeExampleHeading"
        data-testid="representative-example"
      >
        <div className={styles.repHeader}>
          <Text
            id="representativeExampleHeading"
            element={headingLevel}
            fontWeight="bold"
            fontSize="s"
            className={styles.repTitle}
          >
            {representativeExample.title}
          </Text>

          <Text
            fontWeight="book"
            fontSizeFixed="xs"
            className={styles.repBody}
            data-testid="body-copy-variant"
          >
            {representativeExample.bodyCopyVariant}
          </Text>
        </div>
      </section>
    )
  }

  return (
    <section
      className={styles.repExample}
      aria-labelledby="representativeExampleHeading"
      data-testid="representative-example"
    >
      <div className={styles.repHeader}>
        <Text
          id="representativeExampleHeading"
          element={headingLevel}
          fontWeight="bold"
          fontSize="s"
          className={styles.repTitle}
        >
          {representativeExample.title}
        </Text>
        <Text
          fontWeight="book"
          fontSizeFixed="xs"
          className={styles.repBody}
          dangerouslySetInnerHTML={{ __html: representativeExample.bodyCopy }}
        />
      </div>
      <dl className={styles.repDl} data-testid="rep-example-list">
        {representativeExample.descriptionList.map(
          (item: { term: string; details: string }) => (
            <div key={item.term} className={styles.repDlItem}>
              <Text
                element="dt"
                fontSizeFixed="xs"
                fontWeight="book"
                className={styles.repDt}
              >
                {item.term}
              </Text>
              <Text element="dd" fontSizeFixed="xs" fontWeight="bold">
                {item.details}
              </Text>
            </div>
          ),
        )}
      </dl>
    </section>
  )
}

export default RepExample
